import React from 'react';
import { BookOpen, Download } from 'lucide-react';
import { resources } from '../mock';

const Resources = () => {
  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">Resources</h1>
        <p className="body-large page-subtitle">
          Recommended books, study tools, and materials for deeper study.
        </p>

        {/* Recommended Books */}
        <div className="resources-section">
          <h2 className="display-medium section-title">Recommended Free Grace Books</h2>
          <div className="resources-grid">
            {resources.filter(r => r.type === 'Book').map((resource, index) => (
              <div key={index} className="resource-card">
                <div className="resource-icon">
                  <BookOpen size={32} />
                </div>
                <h3 className="heading-3">{resource.title}</h3>
                <p className="body-medium resource-author">by {resource.author}</p>
                <p className="body-small">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Study Tools */}
        <div className="resources-section">
          <h2 className="display-medium section-title">Study Tools</h2>
          <div className="resources-grid">
            {resources.filter(r => r.type === 'Study Tool').map((resource, index) => (
              <div key={index} className="resource-card">
                <div className="resource-icon">
                  <Download size={32} />
                </div>
                <h3 className="heading-3">{resource.title}</h3>
                <p className="body-small">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Scripture Reference Guides */}
        <div className="resources-section">
          <h2 className="display-medium section-title">Scripture Reference Guides</h2>
          <div className="reference-list">
            <div className="reference-card">
              <h3 className="heading-3">Salvation Verses</h3>
              <p className="body-medium">Key passages on justification by faith alone</p>
            </div>
            <div className="reference-card">
              <h3 className="heading-3">Eternal Security Verses</h3>
              <p className="body-medium">Scriptures affirming the believer's eternal security</p>
            </div>
            <div className="reference-card">
              <h3 className="heading-3">Rewards & Inheritance</h3>
              <p className="body-medium">Distinguishing between gift and reward in Scripture</p>
            </div>
          </div>
        </div>

        {/* External Resources */}
        <div className="resources-section">
          <h2 className="display-medium section-title">External Apologetics Resources</h2>
          <p className="body-large">
            Carefully vetted apologetics resources from other ministries and scholars.
          </p>
          <div className="external-resources-list">
            <div className="external-resource-item">
              <h3 className="heading-3">Reasonable Faith</h3>
              <p className="body-medium">William Lane Craig's ministry on philosophical apologetics</p>
            </div>
            <div className="external-resource-item">
              <h3 className="heading-3">Grace Evangelical Society</h3>
              <p className="body-medium">Free Grace theological resources and articles</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;
